export default __webpack_public_path__ + "static/elyxr-page-animation-sample-poster-cae3fc8b5e22241b888a3d0b897f095f.webp";